import React from 'react';

const IconButtonArrow = props => (
    <svg width={props.width || '9'} height={props.height || '17'} viewBox="0 0 9 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill="white" d="M8.26045 9.02252L1.92711 16.1475C1.63835 16.475 1.13893 16.5069 0.810863 16.2188C0.483347 15.93 0.451469 15.4306 0.739613 15.1025L6.60586 8.50002L0.739613 1.89752C0.473769 1.56746 0.515006 1.08659 0.833162 0.806609C1.15132 0.526631 1.63353 0.546868 1.92711 0.852518L8.26045 7.97752C8.523 8.27638 8.523 8.72366 8.26045 9.02252Z" />
    </svg>
);

export default IconButtonArrow;